export default __webpack_public_path__ + "static/media/Emails.126f022b.svg";